import React from 'react'
import { Col } from 'react-bootstrap'

const ReusableChooseUs = ({img}) => {
  return (
    <Col lg={4} xs={6}>
      <div class="choose_us_main ">
        <div class="choose_us_main_img">
          <img src={img}  alt=""/>
        </div>
        <div class="choose_us_main_text">
          <h4>100% Natural</h4>
          <p>Donec sollicitudin molestie malesuada. Lorem ipsum dolor sit amet,consectetur.</p>
        </div>
      </div>
    </Col>
  )
}

export default ReusableChooseUs